import http from 'utils/http.js';

export const getAllPriceTier = () => {
  return http.get(`/pricing/tiers`);
};

export const getAllPriceSize = () => {
  return http.get(`/pricing/sizes`);
};
